const awsExportAlpha = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:be7e4e95-33c6-4988-8b3c-98c623ccc9ca',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_4yPiePpzo',
  aws_user_pools_web_client_id: '1irrpp2138lge9l51osfs32okf',
  oauth: {
    domain: 'bioflux-alpha.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: 'https://alpha.bioflux.io/',
    redirectSignOut: 'https://alpha.bioflux.io/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '961fdb61672a4684b06552d0974bd944',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-cardiac-user-files183955-alpha',
  aws_user_files_s3_bucket_region: 'us-east-2',
  aws_appsync_graphqlEndpoint:
    'https://3p4o3yfo6jeytghtmgjryhkahi.appsync-api.us-east-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};

const awsExportDelta: any = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:f8c49f59-acfc-4b22-863f-46492cd69b4f',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_JR4NGhKK1',
  aws_user_pools_web_client_id: '7o6jcuq4nj4a0vt827pgpv3gmt',
  oauth: {
    domain: 'bioflux-delta.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: 'https://delta.bioflux.io/',
    redirectSignOut: 'https://delta.bioflux.io/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE', 'APPLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_mobile_analytics_app_id: '05d89e01e2134fdb82ecf4a73e3bf8b6',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-cardiac-user-files00045-delta',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const awsExportStaging = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:75b892cd-6e8b-4aa4-858d-c7141980437f',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_56y0nrmHA',
  aws_user_pools_web_client_id: '2hikm48nn3anldt2hrgqhsr5nq',
  oauth: {
    domain: 'bioflux-staging.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: 'https://staging.biotricity.com/',
    redirectSignOut: 'https://staging.biotricity.com/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '90e74b7dac294e87a5d53ccfa6976191',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-cardiac-user-files170212-staging',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const awsExportCustomer = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:d330654d-a73b-4a6f-93ff-595169d13abc',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_admWNuF61',
  aws_user_pools_web_client_id: 'vf5bmsn3ucmfcak5j3eo7a952',
  oauth: {
    domain: 'bioflux-customer.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: 'https://customer.biotricity.com/',
    redirectSignOut: 'https://customer.biotricity.com/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '31eb61bb696a4502814717d9669f3dc2',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-cardiac-user-files234733-customer',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

export { awsExportAlpha, awsExportDelta, awsExportStaging, awsExportCustomer };
